





















import Vue, { PropType } from 'vue'
import mixin from '@/mixins/message-mixin'
import Person from '@/types/Person.interface'
export default Vue.extend({
    mixins: [mixin],
    props: {
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    methods: {
        goToInbox(): void {
            //  Route to this person's channel
            this.$router.push(`/inbox?channel=${this.person.primary_channel_id}`)
        }
    }
})
